import { render } from "./radiobutton-empty.svg?vue&type=template&id=43ef2c2c"
const script = {}

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__